import { useEffect, useState } from "react";
import { SignIn } from "@clerk/clerk-react";
import { Alert } from "@heroui/alert";
import { Button } from "@heroui/button";
import { X } from "lucide-react";

const LoginPage = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallAlert, setShowInstallAlert] = useState(false);
  const [showFallbackAlert, setShowFallbackAlert] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      console.log("✅ beforeinstallprompt fired");
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallAlert(true);
    };

    // Only show fallback if user is not in standalone mode
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    if (!isStandalone) {
      setShowFallbackAlert(true);
    }

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("PWA install accepted");
    } else {
      console.log("PWA install dismissed");
    }

    setDeferredPrompt(null);
    setShowInstallAlert(false);
    setShowFallbackAlert(false);
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-zinc-900 text-white relative">
      {/* Custom install prompt */}
      {showInstallAlert && (
        <div className="absolute top-4 px-4 w-full max-w-md">
          <Alert color="primary" variant="faded"
            title="Install this App?"
            description="Add to your home screen for a better experience."
            endContent={
              <div className="flex gap-2">
                <Button onPress={handleInstallClick} color="primary" size="sm" variant="solid">
                  Install
                </Button>
                <Button onPress={() => setShowInstallAlert(false)} color="default" size="sm" variant="flat">
                  <X className="w-4 h-4" />
                </Button>
              </div>
            }
          />
        </div>
      )}

      {/* Fallback alert if beforeinstallprompt didn’t fire */}
      {!showInstallAlert && showFallbackAlert && (
        <div className="absolute top-4 px-4 w-full max-w-md">
          <Alert
            color="primary"
            variant="faded"
            title="Install this App"
            description="Add it to your home screen, for a better experience"
            endContent={
              <Button onPress={() => setShowFallbackAlert(false)} size="sm" variant="flat">
                <X className="w-4 h-4" />
              </Button>
            }
          />
        </div>
      )}

      <SignIn />
    </div>
  );
};

export default LoginPage;